import { useState } from 'react';

import {
  Row,
  SearchOutlined,
  Select,
  SelectOption,
  Space,
} from 'farmhub-ui-core';

import { theme } from 'styled';

import {
  DesktopWrapper,
  FilterDesktopWrapper,
  SelectDesktopWrapper,
} from './styles';

interface MenuSelectionProps {
  selected: string;
  selectItems: any[];
  handleChangeSelected: (e: string) => void;
  handleChangeSearchValue: (e: string) => void;
}

const MenuSelectionDesktop = ({
  selected,
  selectItems,
  handleChangeSelected,
  handleChangeSearchValue,
}: MenuSelectionProps): JSX.Element => {
  const [searchValue, setSearchValue] = useState('');

  const handleChange = e => {
    setSearchValue(e.target.value);
  };

  const handleEnter = () => {
    handleChangeSearchValue(searchValue);
  };

  return (
    <FilterDesktopWrapper>
      <SelectDesktopWrapper>
        <Select
          defaultValue="all"
          height={theme.select.height.md}
          value={selected}
          width="220px"
          onChange={e => {
            const result = selectItems.find(item => item.entityType == e);

            if (result) {
              result.action();
            }

            handleChangeSelected(e);
          }}
        >
          {selectItems.map((item, index) => (
            <SelectOption
              key={item.entityType}
              label={item.name}
              value={item.entityType}
            >
              <Row>
                {item.icon}
                <Space width={6} /> {item.name}
              </Row>
            </SelectOption>
          ))}
        </Select>
      </SelectDesktopWrapper>
      <DesktopWrapper
        allowClear
        background={theme.colors.text.white}
        height={theme.input.height.md}
        placeholder="Tìm theo tên thực thể"
        prefix={
          <SearchOutlined
            style={{ fontSize: '18px', color: theme.colors.text.secondary }}
          />
        }
        size="large"
        value={searchValue}
        width={307}
        onChange={handleChange}
        onPressEnter={handleEnter}
      />
    </FilterDesktopWrapper>
  );
};

export default MenuSelectionDesktop;
